.categories {
  grid-area: categories;
  display: grid;
  padding-inline: var(--cxy-spacing-xsm);
}
@media screen and (min-width: 801px) {
  .categories {
    padding-inline-start: 0;
  }
}

.sportFilter {
  padding-inline: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: var(--cxy-spacing-xxsm);
}
.sportFilter .pill.active {
  opacity: 1;
}
@media (--cxy-tablet-wide) {
  .sportFilter .pill:hover:not([disabled]) {
    background-color: var(--cxy-color-surface-secondary-default-subtle);
    color: var(--cxy-color-text-default-placeholder);
    opacity: 1;
  }
}
@media (--cxy-desktop) {
  .sportFilter {
    overflow-x: scroll;
  }
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .categories {
    padding-inline: 0;
  }
  .sportFilter {
    padding-inline: var(--cxy-spacing-xsm);

    .pill {
      font-weight: var(--cxy-fontWeight-medium);
    }
  }

  @media screen and (min-width: 801px) {
    .categories {
      padding-inline-end: var(--cxy-spacing-xsm);
    }
    .sportFilter {
      padding-inline: 0;
    }
  }
}
